/* Plugins. */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component.
import CurrencyConverter from '../../CurrencyConverter';
import PromoCode from '../PromoCode/PromoCode';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';

/* Action and helpers. */
import messages from '../../../locale/jsonMessages';
import billDetailsHelpers from '../../../helpers/billDetailsHelper';
import showToaster from '../../../helpers/toasterMessages/showToaster';

// Images.
import { CouponCodeCloseSvg } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { formatLocaleData } from '../../../helpers/formatLocale';

// Style.
import cs from '../../../components/commonStyle.css';
import s from './Calendar.css';


class BillDetails extends Component {
    static propTypes = {
        basePrice: PropTypes.number.isRequired,
        delivery: PropTypes.number,
        currency: PropTypes.string.isRequired,
        monthlyDiscount: PropTypes.number,
        weeklyDiscount: PropTypes.number,
        startDate: PropTypes.object.isRequired,
        endDate: PropTypes.object.isRequired,
        serviceFees: PropTypes.shape({
            guest: PropTypes.shape({
                type: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired,
                currency: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        base: PropTypes.string.isRequired,
        rates: PropTypes.object.isRequired,
        formatMessage: PropTypes.any,
        specialPricing: PropTypes.array,
    };

    static defaultProps = {
        basePrice: 0,
        delivery: 0,
        monthlyDiscount: 0,
        weeklyDiscount: 0,
        startDate: null,
        endDate: null,
        specialPricing: [],
    }

    removePromo = () => {
        const { change } = this.props;
        change("BookingForm", 'promoId', null);
        change("BookingForm", 'promoValue', 0);
        change("BookingForm", 'promoCode', null);
        change("BookingForm", 'promoDiscount', 0);
        change("BookingForm", 'deductionType', 0);
        change("BookingForm", 'description', null);
        change("BookingForm", 'dynamicPromoCode', null);
    }

    getBillDetailsData = (props = this.props) => {
        const {
            specialPricing, serviceFees, monthlyDiscount, weeklyDiscount, base, rates, currency,
            startDate, endDate, startTime, endTime, basePrice, delivery, securityDeposit,
            securityDepositStatus, promoValue, deductionType
        } = props;
        const { formatMessage } = props.intl;

        const securityDepositAmount = securityDepositStatus == 1 ? securityDeposit : 0;

        return billDetailsHelpers({
            specialPricing, serviceFees, monthlyDiscount, weeklyDiscount, base, rates, currency,
            startDate, endDate, startTime, endTime, basePrice, delivery, securityDeposit: securityDepositAmount,
            discountForMonth: formatMessage(messages.monthlyDiscount),
            discountForWeek: formatMessage(messages.weeklyDiscount),
            promoValue, deductionType
        });
    }

    componentDidUpdate(prevProps) {
        const previousBillDetails = this.getBillDetailsData(prevProps);
        const currentBillDetails = this.getBillDetailsData(this.props);

        if (currentBillDetails.discountPromoError && !this.promoErrorHandled) {
            this.promoErrorHandled = true;
            this.removePromo();
            showToaster({ toasterType: "error", messageId: "promoCodeCalculation" });
        }
        if (!currentBillDetails.discountPromoError) {
            this.promoErrorHandled = false;
        }
    }

    render() {
        const { delivery, currency, securityDeposit, securityDepositStatus, change } = this.props;
        const { formatMessage, locale } = this.props.intl;
        const { promoCode, description, isPromoCodeEnabled, promoCodeLoading, dynamicPromoCode } = this.props;

        const dynamicValue = dynamicPromoCode && dynamicPromoCode.find(item => item.language === formatLocaleData(locale));

        let { isAverage, isDayTotal, discount, serviceFee, total, dayDifference, isSpecialPriceAssigned, discountType, priceForDays, hostServiceFee, promoDiscount, discountPromoError } =
            this.getBillDetailsData();
        change("BookingForm", 'isHostServiceEligible', hostServiceFee >= priceForDays ? false : true);
        return (
            <div className={cs.spaceBottom4}>
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                    <div className={cx(cs.commonSmallText16, cs.textStart)}>
                        <div className='tooltipFlex'>
                            {
                                isSpecialPriceAssigned &&
                                <ToolTipSection label={formatMessage(messages.averageRate)}
                                    tooltipIconClass={cx(cs.positionRelative, cs.top3)} />}
                            <div>
                                <CurrencyConverter amount={isAverage} from={currency} />
                                <span className={cs.displayinlineBlock}>&nbsp;{'x'}&nbsp;&rlm;{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span>
                            </div>
                        </div>
                    </div>

                    <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                        <CurrencyConverter amount={isDayTotal} from={currency} />
                    </div>
                </div>
                {
                    discount > 0 && <div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
                        <div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
                        <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                            <span>-&nbsp; <CurrencyConverter amount={discount} from={currency} /> </span>
                        </div>
                    </div>
                }
                {
                    promoDiscount > 0 && <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                        <div className={cx(cs.commonSmallText16, cs.textStart)}>
                            <div className="tooltipFlex">
                                <ToolTipSection label={dynamicValue ? dynamicValue?.description : description} tooltipIconClass={cx(cs.positionRelative, cs.top3)} />
                                <span className='discountText'>{promoCode}</span>
                                <CouponCodeCloseSvg className={cx(cs.positionRelative, cs.top2, 'couponCodeCloseIcon')}
                                    onClick={() => this.removePromo()} />
                            </div>
                        </div>
                        <div className={cx(cs.commonSmallText16, cs.textEnd, 'discountText')}>
                            <span>-&nbsp; <CurrencyConverter amount={promoDiscount} from={currency} /> </span>
                        </div>
                    </div>
                }
                {
                    delivery > 0 && <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                        <div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.cleaningFee} /></div>
                        <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                            <CurrencyConverter amount={delivery} from={currency} />
                        </div>
                    </div>
                }
                {
                    serviceFee > 0 &&
                    <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                        <div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
                        <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                            <CurrencyConverter amount={serviceFee} from={currency} />
                        </div>
                    </div>
                }
                {
                    securityDeposit > 0 && securityDepositStatus == 1 &&
                    <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                        <div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.securityDeposit} /></div>
                        <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                            <CurrencyConverter amount={securityDeposit} from={currency} />
                        </div>
                    </div>
                }
                {
                    (!promoDiscount || promoDiscount <= 0) && isPromoCodeEnabled == 'true' &&
                    <PromoCode
                        containerClass={cs.paymentDivider}
                        promoCodeLoading={promoCodeLoading}
                        promoDiscount={promoDiscount}
                        discount={discount}
                    />
                }

                <div className={cs.dataTableGrid}>
                    <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textStart)}><FormattedMessage {...messages.total} /></div>
                    <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textEnd)}>
                        <CurrencyConverter amount={total} from={currency} />
                    </div>
                </div>
            </div>

        );
    }
}

const selector = formValueSelector('BookingForm'); // <-- same as form name

const mapState = (state) => ({
    specialPricing: state?.viewListing?.specialPricing,
    startTime: selector(state, 'startTime'),
    endTime: selector(state, 'endTime'),
    securityDepositStatus: state?.siteSettings?.data?.securityDepositPreference,
    isPromoCodeEnabled: state?.siteSettings?.data?.isPromoCodeEnabled,
    promoCodeLoading: state?.book?.promoCodeLoading
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(BillDetails)));
